import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import axios from "axios";

export const MarketplaceKeyMetrics = () => {
  const [total, setTotal] = useState(0);
  const [totalSellers, setTotalSellers] = useState(0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_EAS_BASE_URL}/api/messages/count`, {
        headers: {
          apikey: process.env.REACT_APP_EAS_API_KEY,
          "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
        },
      })
      .then((response) => {
        setTotal(response.data.total_messages);
      });

    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/messages/authors/distinct/count`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setTotalSellers(response.data.distinct_authors_count);
      });
  }, []);

  return (
    <Container className={"my-4"} fluid>
      <Card className="d-flex flex-row flex-wrap flex-md-nowrap">
        <MetricContainer
          title={"Signals Intercepted"}
          value={total?.toLocaleString()}
          border={true}
        />
        <MetricContainer
          title={"Sellers"}
          value={totalSellers?.toLocaleString()}
        />
      </Card>
    </Container>
  );
};

const MetricContainer = ({ title, value, border = false }) => {
  const borderStyle =
    border && window.innerWidth >= 768
      ? { borderRight: "1px solid #dee2e6" }
      : { borderRight: "0px solid #dee2e6" };

  return (
    <div className="my-3 px-5" style={borderStyle}>
      <Card.Title className="small fw-normal mb-2">{title}</Card.Title>
      <Card.Subtitle className="p fw-semibold">{value}</Card.Subtitle>
    </div>
  );
};
